import md5 from "@/md5"


//对象排序
const sort = (data) => {
  const newData = {};
  Object.keys(data).sort().map(key => {
    newData[key] = data[key]
  })
  return newData;
}


const isInteger = (value) => {
	if (/^-?\d+$/.test(value)){
		return true;
	}
	return false;
}

const isFloat = (value) => {
	if (/^-?\d+\.\d+$/.test(value)){
		return true;
	}
	return false;

}
//参数格式化

const formatData = (data) => {
  for (const attr in data) {
    if (data[attr] instanceof Object) {
      data[attr] = formatData(data[attr]);
    } else if (data[attr] instanceof Array) {
      data[attr] = formatData(data[attr]);
    }  else {
      data[attr] = ("" + data[attr]).trim();
    }

  }
  return data;
}
const formatDataString = (data) => {
  const str = [];
  for (const attr in data) {
    if (data[attr] instanceof Object) {
      str.push(formatDataString(data[attr]));
    } else if (data[attr] instanceof Array) {
      str.push(formatDataString(data[attr]));
    } else {
      str.push(`${attr  }=${  data[attr]}`);
    }
  }
  return str.join("&");
}

const isEmptyObj = (obj) => {
	for (const key in obj) {
		if ({}.hasOwnProperty.call(obj, key)) return false;
	}
	return true;
}
const md5String = (data) => {
  console.log(encodeURIComponent(formatDataString(data)));
  return md5.hex_md5(encodeURIComponent(formatDataString(data)));
}
const makeSign = (data) => {
  //   console.log(data);
  if (!data || isEmptyObj(data)) {
    return "";
  }
  let key = formatData(data);
  console.log("---------sign data-----------");
  console.log(key)
  // console.log(111)
  key = sort(key);
  return md5String(key);
}

// let key = {
//   "username": "123aa",
//   "age": 12
// };
// let sign = makeSign(key);
// console.log(sign);
export default {
  makeSign,
}
